





import {defineComponent, PropType} from "@vue/composition-api";
import {ProjectEntityInterface} from "@tool/tool.types";
import ProjectLayout from "@tool/Pages/App/Project/layout/ProjectLayout.vue";
import RequiresUpgrade from "@tool/Components/RequiresUpgrade.vue";

export default defineComponent({
    components: {
        ProjectLayout,
        RequiresUpgrade,
    },
    props: {
        project: {
            type: Object as PropType<ProjectEntityInterface>,
            required: true
        },
    },
})
